// 使用咨询
import { Button } from 'antd';
import { RootObject, EasyDeployFotterContent } from '../../type';
// import joinModelHooks from './components/joinModel/joinModelHooks';
// import contactModelHooks from './components/contactModel/contactModelHooks';
// import JoinModel from './components/joinModel/JoinModel';
// import ContactModel from './components/contactModel/ContactModel';
import './style.less';



const EasyDeployFotter = ({
    easyDeployFotter,
    qrCode
}: {
    easyDeployFotter: RootObject["easyDeployFotter"];
    qrCode: RootObject["qrCode"]
}) => {
    //   // 加入我们
    //   const joinModel = joinModelHooks();
    //   // 联系我们
    //   const contactModel = contactModelHooks();

    const onJump = (data: EasyDeployFotterContent) => {
        if (data?.jumpLink) {
            window.open(data?.jumpLink, '_blank')
        }
    }

    return (
        <div className="easy_deploy_fotter">
            <div className="easy_deploy_fotter_head">
                <div className="easy_deploy_fotter_title">
                    {
                        easyDeployFotter.easyDeployFotterTitle ?? ""
                    }
                </div>
                <div className="easy_deploy_fotter_desc">
                    {
                        easyDeployFotter.description ?? ""
                    }
                </div>
            </div>
            <div className="easy_deploy_fotter_content">
                {
                    easyDeployFotter.easyDeployFotterContent.map((value: EasyDeployFotterContent, index: number) => {
                        return (
                            <div className="content_block" key={index}>
                                <div className="block_title">
                                    {value.title ?? ""}
                                </div>
                                <div className="block_des">
                                    {value.titleContent ?? ""}
                                </div>
                                {/* @ts-ignore */}
                                <Button
                                    className="block_btn"
                                    onClick={() => onJump(value)}
                                >
                                    {value.linkName ?? ""}
                                </Button>
                            </div>
                        )
                    })
                }
                {/* 加入我们 */}
                {/* <JoinModel
          {...joinModel}
          qrCode= {qrCode}
        /> */}
                {/* 联系我们 */}
                {/* <ContactModel
          {...contactModel}
        /> */}
            </div>
        </div>
    )
}

export default EasyDeployFotter;